import { atom, getDefaultStore } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import tableViewRepo from '../../../core/repo/viewStateRepo';

// generic view models
import { tableDataVM, tableStateVM, tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';

// ira specific
import { IraDataItem, IraListPageState, IraImportState } from '../ira_types';
import { IRA_LIST_STORAGE_KEY } from '../ira_const';
import { iraImportStateVM, iraListPageStateVM } from './ira_view_models';

// ira atoms
export const pageStateAtom = atom<IraListPageState>(iraListPageStateVM());
export const tableStateAtom = atom<TableState>(tableStateVM());
export const tableViewAtom = atom<TblView>(tableViewVM());
export const tableFiltersAtom = atom<TableFilters>({});
export const tableStatsAtom = atom<TblStats>(tableStatsVM());
export const iraDataAtom = atom<TableDataState<IraDataItem>>(tableDataVM<IraDataItem>());

// import
export const iraImportStateAtom = atom<IraImportState>(iraImportStateVM());

export function setAtomIraListTableViewState(): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(tableFiltersAtom);
    const stats = defaultStore.get<TblStats>(tableStatsAtom);
    const view = defaultStore.get<TblView>(tableViewAtom);
    tableViewRepo.setTable(IRA_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}
